import * as types from 'modules/questionModels/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {string[]} State */
const initialState = [];

const updateQuestionModels = (_, { payload }) => payload.content.map(({ id: questionModelId }) => questionModelId);

const removeOne = (state, { payload: removedId }) => state.filter(questionModelId => questionModelId !== removedId);

export default createReducer(initialState, {
  [types.FETCH_QUESTION_MODELS_SUCCESS]: updateQuestionModels,
  [types.DELETE_QUESTION_MODEL_SUCCESS]: removeOne,
});
